import * as types from "../../../_constants/types";

export default (state = null, action) => {
    switch (action.type) {
        case types.LANGUAGE_LOAD:
            return state = action.data;

        case types.RESET:
        case types.LANGUAGE_RESET:
            return null;

        default:
            return state;
    }
};
